import { useState } from "react";
import { signInWithPopup, FacebookAuthProvider } from "firebase/auth";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { auth } from "../../../utils/MyFirebase";

const provider = new FacebookAuthProvider();

const useFacebookAuth = () => {
  const [user, setUser] = useState();
  const [errors, setErrors] = useState();
  const [signingIn, setSigningIn] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const { t } = useTranslation();

  const signIn = async () => {
    setSigningIn(true);
    try {
      const _signin = await signInWithPopup(auth, provider);
      setUser(_signin.user);
    } catch (error) {
      enqueueSnackbar(t("singin_with_facebook_failed"), { variant: "error" });
      console.log(error);
      setErrors({
        errorCode: error.code,
        errorMessage: error.message,
        email: error.email,
      });
      setSigningIn(false);
    }
  };

  return {
    signIn,
    errors,
    user,
    signingIn,
  };
};

export default useFacebookAuth;
